import { render, staticRenderFns } from "./AppointmentsCallModal.vue?vue&type=template&id=ccb214fc&"
import script from "./AppointmentsCallModal.vue?vue&type=script&lang=js&"
export * from "./AppointmentsCallModal.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentsCallModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports